import React from 'react';
import { Link } from 'react-router-dom';
import { getCopyrightText, getVersionLabel, APP_NAME, getReleaseHint } from '../constants/appInfo';

function AppFooter({ variant = 'default', className = '', fixed = true, linkVersion = false }) {
  const isAuth = variant === 'auth';

  const positionClass = fixed
    ? 'fixed bottom-0 left-0 right-0 z-40'
    : 'w-full shrink-0';

  const themeClass = isAuth
    ? 'bg-blue-900/40 text-white backdrop-blur-sm'
    : 'bg-white border-t border-gray-200 text-gray-600 shadow-[0_-1px_3px_rgba(0,0,0,0.06)]';

  return (
    <footer
      className={`${positionClass} ${themeClass} py-2.5 px-4 text-center text-xs sm:text-sm ${className}`.trim()}
    >
      <p>
        {getCopyrightText()} · {APP_NAME}{' '}
        {linkVersion ? (
          <Link
            to="/about"
            className="font-medium text-primary-600 hover:text-primary-700"
            title={getReleaseHint()}
          >
            {getVersionLabel()}
          </Link>
        ) : (
          <span className="font-medium" title={getReleaseHint()}>
            {getVersionLabel()}
          </span>
        )}
      </p>
    </footer>
  );
}

export default AppFooter;
